import { PreIPODealStatus } from '@constants/common';
import { PreIPODealFormValues } from './types';

export const preIPODealFormDefaultValues: PreIPODealFormValues = {
  id: '',
  status: '',
  isPublish: false,
  isDraft: false,
  companyId: '',

  //Tab3: Deal Details
  preIPOType: '',
  preIPOMode: '',
  isin: '',
  preIPOName: '',
  startDate: null,
  endDate: null,
  minInvestPreIPOTerm: '',
  maxInvestPreIPOTerm: '',
  settlementTime: '',
  paymentDate: '',
  expectedIPODate: '',
  expectedIPODateId: '',
  isinId: '',
  isinTerms: '',
  maxInvestPreIPOTermId: '',
  minInvestPreIPOTermId: '',
  paymentDateId: '',
  settlementTimeId: '',
  maxInvestment: '',
  minInvestment: '',
  preIPOHighlights: [
    {
      id: '',
      title: '',
      description: '',
      sequence: 0
    }
  ],
  coverImage: { file: undefined, path: '' },
  backgroundImage: { file: undefined, path: '' },
  loadingImage: { file: undefined, path: '' },

  //DataRoomTab
  preIPODocuments: [
    {
      id: '',
      title: '',
      description: '',
      document: { file: undefined, path: '' }
    }
  ],
  preIPOContent: [
    {
      id: '',
      title: '',
      description: '',
      url: ''
    }
  ],

  faq: [
    {
      id: '',
      title: '',
      shouldDisplay: false,
      questions: [
        {
          id: '',
          question: '',
          answer: ''
        }
      ]
    }
  ],

  news: [
    {
      id: '',
      url: '',
      order: 0
    }
  ],

  quickLinks: [
    {
      id: '',
      quickLinkEntryId: '',
      url: ''
    }
  ],

  //DealConfigurationTab
  soldOut: false,
  displayNewTag: false,
  linkedOpportunityId: undefined,
  linkedOpportunityType: undefined,

  //TransactionDetailsTab
  isSharePriceAvailable: false,
  chargesAndFees: [],
  carryShortDescription: '',
  carryLongDescription: '',
  sharePriceVisibility: false,
  sharePriceDate: null,
  shortDescription: '',
  longDescription: '',
  versionNumber: 0
};

export const PRE_IPO_FIELD_TO_TAB_MAPPER = {
  0: ['companyId'],
  1: [],
  2: [
    'preIPOType',
    'preIPOMode',
    'isin',
    'preIPOName',
    'startDate',
    'endDate',
    'minInvestment',
    'maxInvestment',
    'preIPOHighlights',
    'coverImage',
    'backgroundImage'
  ],
  3: ['preIPODocuments', 'preIPOContent', 'faq', 'news'],
  4: [],
  5: ['chargesAndFees', 'sharePriceDate']
} as { [x: string]: string[] };

export const PRE_IPO_FIELD_TO_VALUE_MAPPER = {
  companyId: 'Company Id',
  preIPOType: 'Pre-IPO Type',
  preIPOMode: 'Pre-IPO Mode',
  isin: 'ISIN',
  preIPOName: 'Pre-IPO Name',
  startDate: 'Start Date',
  endDate: 'End Date',
  minInvestment: 'Minimum Investment',
  maxInvestment: 'Maximum Investment',
  preIPOHighlights: 'Pre-IPO Highlights',
  coverImage: 'Cover Image',
  shareDetails: 'Share Details',
  preIPODocuments: 'Pre-IPO Documents',
  chargesAndFees: 'Charges and Fees',
  sharePriceDate: 'Share Price Date'
} as { [x: string]: string };

export const PRE_IPO_PUBLISH_ACTIONS = {
  [PreIPODealStatus.ACTIVE]: [
    PreIPODealStatus.IN_REVIEW,
    PreIPODealStatus.ACTIVE
  ],
  [PreIPODealStatus.EXPIRED]: [
    PreIPODealStatus.IN_REVIEW,
    PreIPODealStatus.ACTIVE
  ],
  [PreIPODealStatus.CLOSED]: [
    PreIPODealStatus.IN_REVIEW,
    PreIPODealStatus.CLOSED
  ]
};

export const CreatePreIPODealsCompanyFormDefaultFieldValues = {
  peRatio: '',
  pbRatio: '',
  marketCap: '',
  faceValue: '',
  bookValue: ''
};
